import React from 'react';
import { useTranslation } from 'react-i18next';
import Style from './InviteUserInput.module.css'

const InviteUserInput = ({ email }) => {
    const { t } = useTranslation();
    return (
        <div className={Style.container}>
            <span className={Style.inputLabel}>{email ? t('screens.chat.email') : t('screens.chat.phoneNo')}</span>
            <div className={Style.inputContainer}>
                <svg className={email ? Style.inputEmailIcon : Style.inputIcon}>
                    <use xlinkHref={`/assets/sprite.svg#${email ? 'icon-input-email' : 'icon-input-phone'}`} />
                </svg>
                <input type="text" />
            </div>
        </div>
    )
}

export default InviteUserInput
